import { useCallback } from 'react'

import { useSegment } from '../../../../../hooks'

type ImportTrackArgs =
  | { phase: 'Started' }
  | { phase: 'Completed'; itemCount: number }
  | { phase: 'Failed'; errorReason: string }

const EVENT_NAME_BY_PHASE: Record<ImportTrackArgs['phase'], string> = {
  Started: 'xxx - commerce - Item Import Started',
  Completed: 'Item List Imported (Client)',
  Failed: 'xxx - commerce - Item Import Failed',
}

export const useTrackProductsImport = () => {
  const { track } = useSegment()

  const trackImport = useCallback(
    (args: ImportTrackArgs) => {
      const { phase, ...payload } = args
      track(EVENT_NAME_BY_PHASE[phase], { fileFormat: 'csv', ...payload })
    },
    [track],
  )

  return { trackImport }
}
